import { Component, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrinterService } from '../../data/printer.service';
import { Settings, PrinterTypes } from '../../data/models/models';
import { APP_SETTINGS } from '../../data/settings-data.provider';

@Component({
    selector: 'app-printer-status',
    template: `
    <div class="modal-header">
      <h4 class="modal-title" i18n>Drucker</h4>
      <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
              (click)="activeModal.close()"></button>
    </div>
    <div class="modal-body" *ngIf="printerService.printerStatus as printerStatus">
      <div class="d-flex justify-content-between pb-2">
        <span i18n>Status</span>
        <span *ngIf="printerStatus.printerState === 'online'" i18n>Verbunden und bereit</span>
        <span *ngIf="printerStatus.printerState === 'offline'" i18n>Nicht verbunden</span>
      </div>
      <div class="d-flex justify-content-between pb-2" *ngIf="printerService.supportQueuedJobsClear">
        <span i18n>Warteschleife</span>
        <span *ngIf="printerStatus.jobCount" i18n>{{printerStatus.jobCount}} Aufträge</span>
        <span *ngIf="!printerStatus.jobCount" i18n>Keine Aufträge</span>
      </div>
      <div class="d-flex justify-content-between pb-2" *ngIf="printerStatus.id || isSystemPrinter">
        <span i18n>{{isSystemPrinter ? 'Drucker-Typ' : 'Seriennummer'}}</span>
        <span>{{isSystemPrinter ? 'System-Drucker' : printerStatus.id}}</span>
      </div>
    </div>
    <div *ngIf="printerService.printerStatus?.id && printerService.supportQueuedJobsClear"
         class="modal-footer justify-content-center align-items-center p-2 flex-row">
      <button type="button" class="btn btn-lg btn-danger w-100"
              [appLoadingOverlay]="cancellingPrinterJobs"
              [disabled]="!printerService.canClearQueuedJobs"
              (click)="cancelPrinterJobs()" i18n>
        Warteschleife löschen
      </button>
    </div>
  `,
    standalone: false
})

export class PrinterStatusComponent {
  cancellingPrinterJobs = false;

  constructor(public activeModal: NgbActiveModal,
              public printerService: PrinterService,
              @Inject(APP_SETTINGS) private readonly settings: Settings) {
  }

  get isSystemPrinter(): boolean {
    return this.settings.printerType === PrinterTypes.AIR_PRINT_GENERAL;
  }

  async cancelPrinterJobs() {
    this.cancellingPrinterJobs = true;
    this.printerService.cancelQueuedJobs()
      .finally(() => {
        this.cancellingPrinterJobs = false;
      });
  }
}
